/**
 * Tooltip/index.js
 * desc: tooltip element
 * note: uses radix-ui/react-tooltip component
 */
'use strict';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import './styles.css';
import { classNames } from '../../utilities';

const Tooltip = ({ align="center", arrow=true, alignOffset, asChild, children, contentAriaLabel, contentClassName, open, onOpenChange, onTriggerClick, ref, side="top", sideOffset, text, ...rest }) => {
    const ARROW_HEIGHT = 6;
    const ARROW_WIDTH = 14;
    const DELAY = 500;

    if (text === null) {
        return children;
    }

    return (
        <RadixTooltip.Provider className="component-tooltip-provider" delayDuration={ DELAY }>
            <RadixTooltip.Root open={ open } onOpenChange={ onOpenChange }>
                <RadixTooltip.Trigger className="component-tooltip-trigger" asChild={ asChild } onClick={ onTriggerClick } ref={ ref } { ...rest }>
                    { children }
                </RadixTooltip.Trigger>
                <RadixTooltip.Portal>
                    <RadixTooltip.Content className={ classNames('component-tooltip-content', contentClassName) } align={ align } alignOffset={ alignOffset } aria-label={ contentAriaLabel } side={ side } sideOffset={ sideOffset }>
                        { text }
                        {
                            arrow && <RadixTooltip.Arrow className="component-tooltip-arrow" width= { ARROW_WIDTH } height={ ARROW_HEIGHT } role="figure" />
                        }
                    </RadixTooltip.Content>
                </RadixTooltip.Portal>
            </RadixTooltip.Root>
        </RadixTooltip.Provider>
    );
};


export default Tooltip;
